import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Navbar from './Navbar'
import Footer from './Footer'
import SEO from './SEO'

export default function Legal() {
  const { t } = useTranslation()

  return (
    <>
      <SEO titleKey="seo.legal.title" descriptionKey="seo.legal.description" path="/legal" />
      <Navbar />
      <section className="bg-sand min-h-screen py-24 px-6">
        <div className="max-w-3xl mx-auto font-body text-espresso">
          <Link to="/" className="text-rot text-sm hover:underline mb-8 inline-block">
            {t('impressum.back')}
          </Link>

          <h1 className="font-headline text-4xl md:text-5xl mb-10">{t('impressum.title')}</h1>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('impressum.section1')}</h2>
          <p className="mb-1">
            <strong>Buenas Studio</strong>
          </p>
          <p className="mb-4">Christina Mathis – Marketing &amp; IT Services</p>
          <p className="mb-1">Ctra. de Vila i Beixalis 2/1</p>
          <p className="mb-1">AD200 Encamp</p>
          <p className="mb-4">Andorra</p>
          <p className="mb-1">
            <strong>E-Mail:</strong> hi@buenas-studio.com
          </p>
          <p className="mb-1">
            <strong>Telefon:</strong> +376 681 104 &amp; +43 664 4139250
          </p>
          <p className="mb-1">
            <strong>Website:</strong> buenas-studio.com
          </p>
          <p className="mb-4">
            <strong>{t('impressum.taxLabel')}:</strong> F-401556-M
          </p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('impressum.representedBy')}</h2>
          <p className="mb-4">Christina Mathis</p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('impressum.responsible')}</h2>
          <p className="mb-1">Christina Mathis</p>
          <p className="mb-1">Ctra. de Vila i Beixalis 2/1</p>
          <p className="mb-1">AD200 Encamp</p>
          <p className="mb-4">Andorra</p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('impressum.disclaimer')}</h2>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('impressum.liabilityContent')}</h3>
          <p className="mb-4 leading-relaxed">{t('impressum.liabilityContentText')}</p>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('impressum.liabilityLinks')}</h3>
          <p className="mb-4 leading-relaxed">{t('impressum.liabilityLinksText')}</p>

          <h3 className="font-headline text-xl mt-6 mb-3">{t('impressum.copyright')}</h3>
          <p className="mb-4 leading-relaxed">{t('impressum.copyrightText')}</p>

          <h2 className="font-headline text-2xl mt-8 mb-4">{t('impressum.dispute')}</h2>
          <p className="mb-4 leading-relaxed">{t('impressum.disputeText')}</p>
        </div>
      </section>
      <Footer />
    </>
  )
}
